const memberDataRoleEnum = [
  {
    value: true,
    label: "normal.yes",
    label_tag: "mobile.agentStatus.agent",
    is_translation: true,
  },
  {
    value: false,
    label: "normal.not",
    label_tag: "mobile.agentStatus.notAgent",
    is_translation: true,
  },
];

export default memberDataRoleEnum;
